import { House, Notebook, Postcard, Sunrise } from '@element-plus/icons-vue';

/** 控制菜单数据 */
export const getAsyncRoutes = async () => {
  const localMenus: RouteConfigsTable[] = [
    {
      path: '/welcome',
      meta: {
        title: '欢迎页面',
        icon: House,
      },
      children: [
        {
          path: '/welcome/index',
          name: 'Welcome',
          meta: {
            title: '欢迎页面',
          },
        },
      ],
    },
    {
      path: '/mini-program',
      meta: {
        title: '小程序',
        icon: Postcard,
      },
      children: [
        {
          path: '/mini-program/company-manage',
          name: 'MiniProgramCompanyManage',
          meta: {
            title: '公司管理',
          },
        },
        {
          path: '/mini-program/product-manage',
          name: 'MiniProgramProductManage',
          meta: {
            title: '产品管理',
          },
        },
      ],
    },
    {
      path: '/exhibitor-manage',
      meta: {
        title: '参展&报馆管理',
        icon: Notebook,
      },
      children: [
        {
          path: '/exhibitor-manage/museum-sheet',
          name: 'MuseumSheet',
          meta: {
            title: '展商服务',
          },
        },
        {
          path: '/exhibitor-manage/site-charge',
          name: 'SiteCharge',
          meta: {
            title: '展会现场负责人',
          },
        },
        {
          path: '/exhibitor-manage/exhibitor-badge',
          name: 'ExhibitorBadge',
          meta: {
            title: '参展商证',
          },
        },
        {
          path: '/exhibitor-manage/hotal-order',
          name: 'HotalOrder',
          meta: {
            title: '酒店预订服务',
          },
        },
      ],
    },
    {
      path: '/invite-manage',
      meta: {
        title: '邀约管理',
        icon: Sunrise,
      },
      children: [
        {
          path: '/invite-manage/invite-activity',
          name: 'InviteActivity',
          meta: {
            title: '展商扩邀活动',
          },
        },
        {
          path: '/invite-manage/online-invite',
          name: 'OnlineInvite',
          meta: {
            title: '在线邀请函',
          },
        },
        {
          path: '/invite-manage/online-invite/rank',
          name: 'InviteRank',
          meta: {
            title: '邀约排行榜',
            showLink: false,
          },
        },
        {
          path: '/invite-manage/online-invite/invite-detail',
          name: 'InviteDetail',
          meta: {
            title: '邀约明细',
            showLink: false,
          },
        },
      ],
    },
  ];

  return {
    data: localMenus,
  };
};
